import { Star, Quote } from "lucide-react";
import { REVIEWS, COMPANY } from "../data";
import { Reveal, Eyebrow } from "./Reveal";

const Stars = ({ n }) => (
  <div className="flex gap-0.5 text-[#ffb800]">
    {[...Array(n)].map((_, i) => <Star key={i} className="h-4 w-4" fill="currentColor" />)}
  </div>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <Reveal>
          <Eyebrow>Customer reviews</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight">
            Loved by <span className="flame-text">Essex homes</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-center gap-4 rounded-2xl border border-white/10 bg-[#121217] px-6 py-4">
            <div className="font-display text-4xl font-extrabold flame-text">5.0</div>
            <div>
              <Stars n={5} />
              <a
                href={COMPANY.reviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-reviews-link"
                className="mt-1 block font-mono-sx text-[10px] uppercase tracking-widest text-zinc-400 hover:text-white"
              >
                Verified reviews →
              </a>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
            <figure
              data-testid={`review-card-${i}`}
              className="rounded-3xl border border-white/10 bg-[#121217] p-6 hover:border-[#f5641e]/40 transition-colors"
            >
              <div className="flex items-center justify-between">
                <Stars n={r.rating} />
                <Quote className="h-6 w-6 text-white/10" />
              </div>
              <blockquote className="mt-4 text-zinc-300 leading-relaxed">"{r.text}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#f5641e] font-display font-bold text-[#0a0a0c]">
                  {r.name[0]}
                </div>
                <div>
                  <div className="font-semibold text-white">{r.name}</div>
                  <div className="font-mono-sx text-[10px] uppercase tracking-widest text-zinc-500">{r.location}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
